import * as angular from 'angular';
import 'data/array';
export class SidebarContentService {
    static $inject = ['$q', '$document', '$rootScope', '$compile', '$controller', '$animate', '$timeout'];
    constructor($q, $document, $rootScope, $compile, $controller, $animate, $timeout) {
        'ngInject';
        this.$q = $q;
        this.$document = $document;
        this.$rootScope = $rootScope;
        this.$compile = $compile;
        this.$controller = $controller;
        this.$animate = $animate;
        this.$timeout = $timeout;
        //Track open sidebars
        this.openSidebars = [];
    }
    /**
     * Method to show sidebar
     * @param options - {controller, controllerAs, template, allowMultiple, inputs}
     */
    async showSidebar(options) {
        //Modal promisse
        const deferred = this.$q.defer();
        if (!options.allowMultiple && this.openSidebars.length > 0) {
            this.openSidebars.forEach((sidebar) => {
                this.cleanAndClose(false, sidebar);
            });
        }
        const closeDeferred = this.$q.defer();
        const sidebarScope = this.$rootScope.$new();
        if (!options.controller) {
            deferred.reject('No controller has been specified');
            return deferred.promise;
        }
        const body = angular.element(options.appendToElement);
        //the element is undefined because is compiled later on
        const sidebarContent = {
            scope: sidebarScope,
            element: undefined,
            closeDeferred: closeDeferred,
            type: options.type,
            sidebarId: options.sidebarId,
        };
        const inputs = {
            $scope: sidebarScope,
            $rootScope: this.$rootScope,
            close: (result) => {
                this.$timeout(() => this.cleanAndClose(result, sidebarContent), 0);
            },
            ...options.inputs,
        };
        const controllerObjBefore = sidebarScope[options.controllerAs];
        let sidebarContentController = this.$controller(options.controller, inputs);
        //merge scopes
        if (options.controllerAs && controllerObjBefore) {
            sidebarContentController = {
                ...sidebarContentController,
                ...controllerObjBefore,
            };
        }
        // Attach the controller to the scope with the controllerAs name so template bindings work
        if (options.controllerAs) {
            sidebarScope[options.controllerAs] = sidebarContentController;
            console.debug('[SidebarContentService] Attached controller to scope as', options.controllerAs, sidebarContentController);
        }
        //compile element and added to the sidebar content to be used in the remove method
        sidebarContent.element = this.$compile(options.template)(sidebarContentController.$scope || sidebarScope);
        this.appendChild(body, sidebarContent.element);
        this.openSidebars = this.openSidebars.concat(sidebarContent);
        const deregisterLocationChangeSuccess = this.$rootScope.$on('$locationChangeSuccess', ($event) => {
            this.cleanAndClose(false);
        });
        sidebarScope.$on('$destroy', () => {
            deregisterLocationChangeSuccess();
        });
        deferred.resolve(sidebarContent);
        // Clear previous input focus to avoid open multiple sidebars on enter
        document.activeElement.blur();
        return deferred.promise;
    }
    cleanAndClose(result, sidebarContent) {
        if (sidebarContent) {
            this.closeSidebar(sidebarContent, result);
            this.openSidebars = this.openSidebars.filter((e) => e != sidebarContent);
        }
        else {
            this.openSidebars.forEach((openSidebarContent) => {
                this.closeSidebar(openSidebarContent, result);
            });
            this.openSidebars = [];
        }
    }
    closeSidebar(sidebarContent, result) {
        this.$animate.leave(sidebarContent.element);
        sidebarContent.scope.$destroy();
        sidebarContent.closeDeferred.resolve(result);
    }
    appendChild(parent, child) {
        const children = parent.children();
        if (children.length > 0) {
            return this.$animate.enter(child, parent, children[children.length - 1]);
        }
        return this.$animate.enter(child, parent);
    }
    getSidebars() {
        return this.openSidebars;
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
SidebarContentService.$inject = ['$q', '$document', '$rootScope', '$compile', '$controller', '$animate', '$timeout'];
export class SidebarContent {
}
export var SidebarContentTypes;
(function (SidebarContentTypes) {
    SidebarContentTypes["BuilderActionSidebar"] = "BuilderActionSidebar";
})(SidebarContentTypes || (SidebarContentTypes = {}));
